import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainBlock } from './components/PainBlock';
import { Transition } from './components/Transition';
import { EbookIntro } from './components/EbookIntro';
import { WhatYouLearn } from './components/WhatYouLearn';
import { Chapters } from './components/Chapters';
import { InsidePreview } from './components/InsidePreview';
import { Bonuses } from './components/Bonuses';
import { Transformation } from './components/Transformation';
import { PricingCountdown } from './components/PricingCountdown';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfNotHaving } from './components/CostOfNotHaving';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) return;
    const pixelScript = document.createElement('script');
    pixelScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '790333870788238');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(pixelScript);
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-text-dark selection:bg-peach selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainBlock data-id="element-3" />
      <Transition data-id="element-4" />
      <EbookIntro data-id="element-5" />
      <WhatYouLearn data-id="element-6" />
      <Chapters data-id="element-7" />
      <InsidePreview data-id="element-8" />
      <Bonuses data-id="element-9" />
      <Transformation data-id="element-10" />
      <PricingCountdown data-id="element-11" />
      <MoreTestimonials data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <CostOfNotHaving data-id="element-15" />
      <FinalOffer data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}